import React from 'react';
import { CheckSquare, Square } from 'lucide-react';
import { dataIt } from '../haccpApi';
import { BadgeLivello } from './BadgeRichiamo';

const Riga = ({ scelta, onCambia, testid, children, livello, motivi }) => (
  <button type="button" onClick={onCambia} data-testid={testid}
    className={`w-full text-left rounded-xl border p-3 flex gap-3 ${scelta ? 'border-red-500 bg-red-50' : 'border-gray-200 bg-white'}`}>
    {scelta ? <CheckSquare className="h-5 w-5 text-red-600 shrink-0 mt-0.5" /> : <Square className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />}
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 flex-wrap"><BadgeLivello livello={livello} testid={`${testid}-livello`} /></div>
      {children}
      {!!motivi?.length && <p className="text-[11px] text-gray-500 mt-1">{motivi.join(' · ')}</p>}
    </div>
  </button>
);

export const RisultatiRicerca = ({ risultati, merce, setMerce, prep, setPrep }) => {
  const cambia = (set, chiave) => set((s) => (s.includes(chiave) ? s.filter((x) => x !== chiave) : [...s, chiave]));
  return (
    <div className="space-y-5" data-testid="richiamo-risultati">
      <div className="space-y-2">
        <h4 className="text-sm font-bold text-gray-900">Acquisti trovati ({risultati.merce.length})</h4>
        {!risultati.merce.length && <p className="text-sm text-gray-600" data-testid="richiamo-nessun-acquisto">Nessun DDT o fattura con questo prodotto.</p>}
        {risultati.merce.map((m) => (
          <Riga key={m.chiave} scelta={merce.includes(m.chiave)} onCambia={() => cambia(setMerce, m.chiave)} livello={m.livello}
            motivi={m.motivi} testid={`richiamo-merce-${m.chiave.replace(/[^a-zA-Z0-9-]/g, '-')}`}>
            <p className="text-sm font-semibold text-gray-900 mt-1 break-words">{m.prodotto}</p>
            <p className="text-xs text-gray-600">{m.documento} del {dataIt(m.data)} · {m.fornitore || '-'}
              {m.quantita ? ` · ${m.quantita} ${m.unita || ''}` : ''}{m.lotto ? ` · lotto ${m.lotto}` : ''}</p>
          </Riga>
        ))}
      </div>
      <div className="space-y-2">
        <h4 className="text-sm font-bold text-gray-900">Preparazioni da bloccare ({risultati.preparazioni.length})</h4>
        {!risultati.preparazioni.length && <p className="text-sm text-gray-600" data-testid="richiamo-nessuna-preparazione">Nessuna preparazione contiene questo prodotto.</p>}
        {risultati.preparazioni.map((p) => (
          <Riga key={p.lotto_id} scelta={prep.includes(p.lotto_id)} onCambia={() => cambia(setPrep, p.lotto_id)} livello={p.livello}
            motivi={p.motivi} testid={`richiamo-prep-${p.lotto_id}`}>
            <p className="text-sm font-semibold text-gray-900 mt-1">{p.nome} <span className="font-normal text-gray-500">· lotto {p.numero_lotto}</span></p>
            <p className="text-xs text-gray-600">Prodotta il {dataIt(p.data)} · scade il {dataIt(p.data_scadenza)} · {p.ingrediente}
              {p.gia_richiamato ? ` · già nel richiamo ${p.gia_richiamato}` : ''}</p>
          </Riga>
        ))}
      </div>
    </div>
  );
};
